import { TrackingEvent } from '@y42/core/user-tracking';

// https://docs.google.com/spreadsheets/d/1b2CQGf8nyzGMJkcRgrYHZVq2aVSD7DN1VkeyefvtFVE/edit#gid=976767472
export class OrgSelectedTrackingEvent extends TrackingEvent {
  readonly name = 'Org Selected';
}
